import { render, staticRenderFns } from "./DeviceRomAutoUpload.vue?vue&type=template&id=5470e4b7&scoped=true"
import script from "./DeviceRomAutoUpload.vue?vue&type=script&lang=js"
export * from "./DeviceRomAutoUpload.vue?vue&type=script&lang=js"
import style0 from "./DeviceRomAutoUpload.vue?vue&type=style&index=0&id=5470e4b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470e4b7",
  null
  
)

export default component.exports